import * as React from "react";
import { Box, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material";
import { connect } from "react-redux";
import { getRequest } from "../core/network";
import endpoints from "../constants/endPoints.json";
import { centered_flex_box } from "../app/components/Styles";
import { notification } from "antd";
import { useTranslation } from "react-i18next";

export const ConfirmItDashboard = ({ token, user }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [embedUrl, setEmbedUrl] = React.useState("");

  const confirmItUUID = user?.vendor?.confirmItUUID;

  React.useEffect(() => {
    if (!confirmItUUID) {
      setLoading(false);
      setError("Vendor does not have a ConfirmIt UUID");
      return;
    }

    setLoading(true);
    setError("");
    getRequest({}, undefined, token, endpoints.partner.confirmitDashboard)
      .then((response) => {
        const url = response?.data?.embed_url;
        if (!url) {
          throw new Error("Failed to load ConfirmIt dashboard");
        }
        setEmbedUrl(url);
      })
      .catch((err) => {
        const message = err?.response?.data?.message || err?.message || "Failed to load ConfirmIt dashboard";
        setError(message);
        notification.error({ message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token, confirmItUUID]);

  const pageHeight = isMobile ? "calc(100dvh - 60px)" : "calc(100vh - 96px)";

  return (
    <Box sx={{ width: "100%", height: pageHeight, display: "flex", flexDirection: "column", gap: 2 }}>
      <div style={{ fontSize: 34, fontWeight: 600 }}>{t("settings.confirmIt")}</div>
      {loading ? (
        <Box sx={{ ...centered_flex_box, height: "100%" }}>
          <CircularProgress sx={{ color: "var(--primaryColor)" }} />
        </Box>
      ) : error ? (
        <Box sx={{ ...centered_flex_box, height: "100%" }}>
          <Typography sx={{ color: "var(--textSecondary)" }}>{error}</Typography>
        </Box>
      ) : (
        <iframe
          title="ConfirmIt Dashboard"
          src={embedUrl}
          width="100%"
          height="100%"
          style={{ border: 0, display: "block" }}
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  token: state?.auth?.token,
  user: state?.auth?.user,
});

export default connect(mapStateToProps)(ConfirmItDashboard);
